import { Avatar, Grid, Paper, Stack, Typography } from "@mui/material";
import "./Counters.css";
import { useNavigate } from "react-router";

function Counter({ backgroundColor, icon, label, value, navigateTo, filter }) {
  const navigate = useNavigate();

  return (
    <Grid item xs={4} className={"gridBox"}>
      <Paper
        elevation={2}
        sx={{ backgroundColor }}
        className={"paperBox hoverable"}
        onClick={() => {
          navigate(navigateTo, { state: filter });
        }}
      >
        <div className={"stackBox"}>
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <Avatar sx={{ backgroundColor: "transparent" }}>{icon}</Avatar>
            <Typography className={"typography"}>
              {label}: <br />
              <strong>{value}</strong>
            </Typography>
          </Stack>
        </div>
      </Paper>
    </Grid>
  );
}

export default Counter;
